import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Box, Typography, IconButton, Paper, InputBase } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { styled } from '@mui/material/styles';
import UserHeader from '../../component/reusable/UserHeader';
import Cards from '../../component/reusable/Cards';
import AllBomOrderTable from '../../component/bomComps/AllBomOrderTable';
import BomOrderCard from '../../component/bomComps/BomOrderCard';
import BomOrderTab from '../../component/bomComps/BomOrderTab';
import { exportDataExcel, fomateDate } from '../../utils/fomateDate';
import { deletevendorExcessThunk, exportvendorExcessThunk, getAllvendorExcessThunk, getvendorExcessStatisticsThunk, setvendorExcessFromDate, setvendorExcessPage, setvendorExcessSearch, setvendorExcessSelectedTab, setvendorExcessToDate } from '../../redux/vendorExcessSlice';
import BomOrderFilter from '../../component/bomComps/BomOrderFilter';
import VendorExcessInventoryTable from '../../component/excessInventoryComps/VendorExcessInventoryTable';
import VendorExcessFilter from '../../component/excessInventoryComps/VendorExcessFilter';
import VendorExcessTab from '../../component/excessInventoryComps/VendorExcessTab';
import VendorExcessCard from '../../component/excessInventoryComps/VendorExcessCard';


function VendorExcessInventory() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [allStatus, setAllStatus] = useState('')
    const [limit, setLimit] = useState(25)
    const [sortBy, setSortyBy] = useState('createdAt');
    // Newest first by default; ascending only when picked from a column menu
    const [order, setOrder] = useState('desc')
    const [selectedId, setSelectedId] = useState(null)
    const [isModalOpen, setIsModalOpen] = useState(false);

    const deleteCategory = (password) => {
        dispatch(deletevendorExcessThunk({ id: selectedId, password }))
        setIsModalOpen(false);

    }


    //delete modal open
    const handleDeleteClick = (id) => {
        setIsModalOpen(true);
        setSelectedId(id)
    };


    const handleChange = (event, newValue) => {
        dispatch(setvendorExcessSelectedTab(newValue))
        setAllStatus('')
        dispatch(setvendorExcessPage(1))
        dispatch(setvendorExcessSearch(''))
        dispatch(setvendorExcessFromDate(''))
        dispatch(setvendorExcessToDate(''))
    };

    const { excess, loading, refresh, page, search, fromDate, toDate, exportLoading, selectedTab, orderStatistics } = useSelector((state) => state.vendorexcess);
    const excessData = excess?.data
    const totalPages = excess?.totalPages
    const totalItems = excess?.totalItems
    const itemsPerPage = excess?.limit

    console.log(excessData);

    const start = (page - 1) * limit + 1;
    const end =
        totalPages === page
            ? totalItems
            : (page - 1) * limit + limit;

    const status = selectedTab === 0 ? allStatus : selectedTab === 1 ? 'NEW' : selectedTab === 2 ? 'APPROVED' : selectedTab == 3 ? "REJECTED" : "DELETED"

    //    console.log(excess);

    useEffect(() => {
        dispatch(getAllvendorExcessThunk(`?search=${search}&page=${page}&status=${status}&fromDate=${fromDate}&toDate=${toDate}&sortBy=${sortBy}&order=${order}&limit=${limit}&orderType=EXCESS`));
    }, [page, search, status, limit, refresh, sortBy, order, fromDate, toDate]);


    // Status values offered in the Status column menu (only on the "All" tab, the other tabs are already one status)
    const statusFilterOptions = [{ value: 'NEW', label: 'New' }, { value: 'APPROVED', label: 'Approved' }, { value: 'REJECTED', label: 'Rejected' }];

    const handleStatusFilter = (value) => {
        setAllStatus(value)
        dispatch(setvendorExcessPage(1))
    };

    // Date / Status column menus: pick descending / ascending explicitly and start again from page 1
    const handleColumnSort = (field, direction) => {
        setSortyBy(field)
        setOrder(direction)
        dispatch(setvendorExcessPage(1))
    };

    const handleOpenMenu = (sort) => {
        setSortyBy(sort)
        setOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    };

    const exportexcessenq = async () => {
        const status = await dispatch(exportvendorExcessThunk(`?limit=${100000}&orderType=EXCESS`))
        if (status?.payload?.success === true) {
            console.log("status", status?.payload?.data);

            const exportOrderData = status?.payload?.data
            const exportdata = exportOrderData?.map((item) => ({
                'id': item?._id || '-',
                'Name': item?.user?.fullName || '-',
                'Company': item?.user?.companyName || '-',

                'products': item?.productCount + 'products',
                'Total': item?.total || '-',
                'Status': item?.status || '-',
                'CreatedAt': fomateDate(item?.createdAt),
            }))
            // console.log("expo", exportdata);

            exportDataExcel(exportdata, "excess")
        }
    }



    useEffect(() => {
        dispatch(getvendorExcessStatisticsThunk())
    }, [])

    return (
        <>
            <UserHeader
                index="Vendors : Excess Inventory"
                root="Dashboard"
                exportData={exportexcessenq}
                exportLoading={exportLoading}
                hideadd={'hide'}
            />

            <VendorExcessCard orderStatistics={orderStatistics} />

            <Box>

                <VendorExcessTab handleChange={handleChange} selectedTab={selectedTab} />
                <VendorExcessFilter
                    setAllStatus={setAllStatus}
                    search={search} selectedTab={selectedTab}
                    setOrderFromDate={setvendorExcessFromDate}
                    setOrderToDate={setvendorExcessToDate}
                    setSearch={setvendorExcessSearch}
                />

                <Box >
                    {
                        loading ?
                            <div style={{ display: 'flex', justifyContent: 'center' }}>Loading...</div>
                            :
                            <>
                                {excessData?.length > 0 ?
                                    <Typography>
                                        <VendorExcessInventoryTable
                                            bomData={excessData}
                                            page={page}
                                            setPage={setvendorExcessPage}
                                            itemsPerPage={itemsPerPage}
                                            totalItems={totalItems}
                                            totalPages={totalPages}
                                            start={start}
                                            end={end}
                                            handleOpenMenu={handleOpenMenu}
                                            dateOrder={sortBy === 'createdAt' ? order : null}
                                            onDateSort={(direction) => handleColumnSort('createdAt', direction)}
                                            statusOrder={sortBy === 'status' ? order : null}
                                            onStatusSort={(direction) => handleColumnSort('status', direction)}
                                            statusFilterOptions={selectedTab === 0 ? statusFilterOptions : null}
                                            statusFilterValue={allStatus}
                                            onStatusFilterChange={handleStatusFilter}
                                            selectedTab={selectedTab}
                                            handleDeleteClick={handleDeleteClick}
                                            deleteCategory={deleteCategory}
                                            setIsModalOpen={setIsModalOpen}
                                            isModalOpen={isModalOpen}
                                            path={'/excess/VendorExcessDetails'}
                                        />
                                    </Typography>
                                    :
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        No Data found
                                    </div>
                                }
                            </>
                    }
                </Box>

            </Box>
        </>
    );
}

export default VendorExcessInventory;
